import { Node } from '@tiptap/core';

export const ColumnLayout = {
  TwoColumn: 'two-column',
  ThreeColumn: 'three-column',
};

const Columns = Node.create({
  name: 'columns',
  group: 'block',
  content: 'column{2,3}',
  defining: true,
  isolating: true,

  addAttributes() {
    return {
      layout: {
        default: ColumnLayout.ThreeColumn,
      },
    };
  },

  addCommands() {
    return {
      setTopDeal: () => ({ commands }) =>
        commands.insertContent({
          type: 'columns',
          content: [
            { type: 'column', attrs: { position: 'left' }, content: [{ type: 'paragraph' }] },
            { type: 'column', attrs: { position: 'center' }, content: [{ type: 'paragraph' }] },
            { type: 'column', attrs: { position: 'right' }, content: [{ type: 'paragraph' }] }
          ]
        }),
      setLayout:
        (layout) =>
          ({ state, dispatch }) => {
            const { selection, schema } = state;
            const { $from } = selection;

            // Find parent columns node
            let columnsPos = null;
            let columnsNode = null;

            for (let d = $from.depth; d > 0; d--) {
              const node = $from.node(d);
              if (node.type.name === 'columns') {
                columnsNode = node;
                columnsPos = $from.before(d);
                break;
              }
            }

            if (!columnsNode || columnsPos === null) return false;

            const columnType = schema.nodes.column;
            const paragraphType = schema.nodes.paragraph;

            let newColumns = [];

            // TWO COLUMN
            if (layout === ColumnLayout.TwoColumn) {
              const left = columnsNode.child(0);
              const right = columnsNode.child(columnsNode.childCount - 1);

              newColumns = [
                left.copy(left.content),
                right.copy(right.content),
              ];
            }

            // THREE COLUMN
            if (layout === ColumnLayout.ThreeColumn) {
              const left = columnsNode.child(0);
              const right = columnsNode.child(columnsNode.childCount - 1);

              const center = columnType.create(
                { position: 'center' },
                paragraphType.create()
              );

              newColumns = [
                left.copy(left.content),
                center,
                right.copy(right.content),
              ];
            }

            const newColumnsNode = schema.nodes.columns.create(
              { layout },
              newColumns
            );

            const tr = state.tr.replaceWith(
              columnsPos,
              columnsPos + columnsNode.nodeSize,
              newColumnsNode
            );

            dispatch(tr);
            return true;
          },


    };
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', {
      'data-type': 'columns',
      'data-layout': HTMLAttributes.layout,
      class: `top-deal-columns-block layout-${HTMLAttributes.layout}`
    }, 0];
  },

  parseHTML() {
    return [{
      tag: 'div[data-type="columns"]',
      getAttrs: (element) => ({
        layout: element.getAttribute('data-layout') || ColumnLayout.ThreeColumn,
      }),
    }];
  },
});

export default Columns;
